var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"border-bottom pointer",on:{"click":_setup.openAsset}},[_c('v-col',[_c(_setup.is,{tag:"component",attrs:{"entity":_vm.entity}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }